import React, { useContext, useEffect, useState } from 'react'
import "swiper/css";
import "swiper/css/pagination";
import AuthService from '../../../api/services/AuthService';
import { SocketContext } from "../../../customComponents/SocketContext";
import { Link } from 'react-router-dom';
import DashboardHeader from '../../../customComponents/DashboardHeader';
import LoaderHelper from '../../../customComponents/Loading/LoaderHelper';
import { alertErrorMessage } from '../../../customComponents/CustomAlertMessage';
import { formatPnl, pnlClass, pnlUsdt } from '../CopyTrading/helpers';
import './dashboard.css';


const Dashboard = (props) => {
  const { socket } = useContext(SocketContext);
  const [highlightCoins, setHighlightCoins] = useState({ new: {}, topGainer: {}, topLoser: {}, topVolumne: {} });
  const [copyPnl, setCopyPnl] = useState({ totalPnl: 0, perMaster: [] });

  const loadCopyTradingPnl = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.copyTradingPnl();
      if (result?.success) {
        setCopyPnl(result?.data || { totalPnl: 0, perMaster: [] });
      } else {
        setCopyPnl({ totalPnl: 0, perMaster: [] });
        if (result?.message) alertErrorMessage(result.message);
      }
    } catch (error) {
      setCopyPnl({ totalPnl: 0, perMaster: [] });
    }
    LoaderHelper.loaderStatus(false);
  };

  useEffect(() => {
    let interval;
    if (socket) {
      let payload = {
        'message': 'market',
      }
      socket.emit('message', payload);
      interval = setInterval(() => {
        let payload = {
          'message': 'market',
        }
        socket.emit('message', payload);
      }, 2000)

      socket.on('message', (data) => {
        const pairs = data?.pairs || [];
        if (!pairs.length) return;

        let topGainer = pairs.reduce((max, item) => {
          return parseFloat(item.change) > parseFloat(max.change) ? item : max;
        }, pairs[0]);

        let topLoser = pairs.reduce((min, item) => {
          return parseFloat(item.change) < parseFloat(min.change) ? item : min;
        }, pairs[0]);

        let newest = [...pairs].reverse()[0];

        const validVolumePairs = pairs.filter(item => item?.volume !== undefined && item?.volume !== null);

        const highestVolumePair = validVolumePairs?.reduce((max, item) => {
          return parseFloat(item.volume) > parseFloat(max.volume) ? item : max;
        }, validVolumePairs[0]);

        setHighlightCoins({ new: newest || {}, topGainer: topGainer || {}, topLoser: topLoser || {}, topVolumne: highestVolumePair || {} });

      });
    }
    return (() => {
      clearInterval(interval)
    })
  }, [socket]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    loadCopyTradingPnl()
  }, []);

  



  const masters = copyPnl?.perMaster || [];
  const followingCount = masters.filter((item) => item?.isFollowing).length;
  const totalPnl = Number(copyPnl?.totalPnl) || 0;
  const pnlTone = totalPnl > 0 ? "up" : totalPnl < 0 ? "down" : "flat";
  const pnlToneLabel = totalPnl > 0 ? "In profit" : totalPnl < 0 ? "In loss" : "Break even";

  return (
    <>
      <div className="dashboard_right">

        <DashboardHeader props={props} />
        <div className="estimated_balance">
          <div className='div_tag'>
            <div className="balance_chart_left">
              <div className="d-flex justify-content-between">
                <h4>Newest (Pair)</h4> <Link to="/market">  <i className="ri-arrow-right-s-line"></i></Link>
              </div>
              <div className="select_price">
                <ul className='wallet_price_list'>
                  <li><h3 className={`${highlightCoins?.new?.change > 0 ? "text-success" : "text-danger"}`}>{highlightCoins?.new?.buy_price || 0.00} {highlightCoins?.new?.quote_currency || "---"} | {highlightCoins?.new?.change || 0.00}%</h3></li>
                  <li><span>≈ {highlightCoins?.new?.base_currency_fullname || "---"}</span></li>
                </ul>
                <div className="dashboardsummary_bottom">
                  <h4>{highlightCoins?.new?.base_currency || "---"}/{highlightCoins?.new?.quote_currency || "---"}</h4>
                  <Link className="btn" to={`/trade/${highlightCoins?.new?.base_currency || "base"}_${highlightCoins?.new?.quote_currency || "quote"}`}>Make Trade</Link>
                </div>

              </div>
            </div>
          </div>

          <div className='div_tag'>
            <div className="balance_chart_left">
              <div className="d-flex justify-content-between">
                <h4>Top gainer (24h)</h4> <Link to="/market">  <i className="ri-arrow-right-s-line"></i></Link>
              </div>
              <div className="select_price">

                <ul className='wallet_price_list'>
                  <li><h3 className={`${highlightCoins?.topGainer?.change > 0 ? "text-success" : "text-danger"}`}>{highlightCoins?.topGainer?.buy_price || 0.00} {highlightCoins?.topGainer?.quote_currency || "---"} | {highlightCoins?.topGainer?.change || 0.00}%</h3></li>
                  <li><span>≈ {highlightCoins?.topGainer?.base_currency_fullname || "---"}</span></li>
                </ul>

                <div className="dashboardsummary_bottom">
                  <h4>{highlightCoins?.topGainer?.base_currency || "---"}/{highlightCoins?.topGainer?.quote_currency || "---"}</h4>
                  <Link className="btn" to={`/trade/${highlightCoins?.topGainer?.base_currency || "base"}_${highlightCoins?.topGainer?.quote_currency || "quote"}`}>Make Trade</Link>
                </div>
              </div>
            </div>
          </div>

          <div className='div_tag'>
            <div className="balance_chart_left">
              <div className="d-flex justify-content-between">
                <h4>Top Loser (24h)</h4><Link to="/market">  <i className="ri-arrow-right-s-line"></i></Link>
              </div>
              <div className="select_price">

                <ul className='wallet_price_list'>
                  <li><h3 className={`${highlightCoins?.topLoser?.change > 0 ? "text-success" : "text-danger"}`}>{highlightCoins?.topLoser?.buy_price || 0.00} {highlightCoins?.topLoser?.quote_currency || "---"} | {highlightCoins?.topLoser?.change || 0.00}%</h3></li>
                  <li><span>≈ {highlightCoins?.topLoser?.base_currency_fullname || "---"}</span></li>
                </ul>

                <div className="dashboardsummary_bottom">
                  <h4>{highlightCoins?.topLoser?.base_currency || "---"}/{highlightCoins?.topLoser?.quote_currency || "---"}</h4>
                  <Link className="btn" to={`/trade/${highlightCoins?.topLoser?.base_currency || "base"}_${highlightCoins?.topLoser?.quote_currency || "quote"}`}>Make Trade</Link>
                </div>
              </div>
            </div>
          </div>

          <div className='div_tag'>
            <div className="balance_chart_left">
              <div className="d-flex justify-content-between">
                <h4>High Volume (24H)</h4> <Link to="/market">  <i className="ri-arrow-right-s-line"></i></Link>
              </div>
              <div className="select_price">

                <ul className='wallet_price_list'>
                  <li><h3 className={`${highlightCoins?.topVolumne?.change > 0 ? "text-success" : "text-danger"}`}>{highlightCoins?.topVolumne?.buy_price || 0.00} {highlightCoins?.topVolumne?.quote_currency || "---"} | {highlightCoins?.topVolumne?.change || 0.00}%</h3></li>
                  <li><span>≈ {highlightCoins?.topVolumne?.base_currency_fullname || "---"}</span></li>
                </ul>

                <div className="dashboardsummary_bottom">
                  <h4>{highlightCoins?.topVolumne?.base_currency || "---"}/{highlightCoins?.topVolumne?.quote_currency || "---"}</h4>
                  <Link className="btn" to={`/trade/${highlightCoins?.topVolumne?.base_currency || "base"}_${highlightCoins?.topVolumne?.quote_currency || "quote"}`}>Make Trade</Link>
                </div>
              </div>
            </div>
          </div>

        </div>

        <div className="dashboard_listing_section">
          <div className="listing_left_outer">
            <div className="market_section maindashboard dash_ct_pnl">
              <div className={`dash_ct_panel tone-${pnlTone}`}>
                <div className="dash_ct_head">
                  <div>
                    <span className="dash_ct_kicker">Copy Trading</span>
                    <h4>P&L Overview</h4>
                  </div>
                  <Link className="dash_ct_more" to="/copy-trading">View details</Link>
                </div>
                <div className="dash_ct_hero">
                  <div className="dash_ct_hero_main">
                    <div className="dash_ct_hero_top">
                      <label>Total PnL</label>
                      <span className={`dash_ct_tone dash_ct_tone_${pnlTone}`}>{pnlToneLabel}</span>
                    </div>
                    <h2 className={pnlClass(totalPnl)}>
                      {formatPnl(totalPnl)}
                      <small>USDT</small>
                    </h2>
                    <p>Spot wallet settlement · USDT</p>
                  </div>
                  <div className="dash_ct_stats">
                    <div className="dash_ct_stat">
                      <span className="dash_ct_stat_n">{masters.length}</span>
                      <label>Masters copied</label>
                    </div>
                    <div className="dash_ct_stat">
                      <span className="dash_ct_stat_n">{followingCount}</span>
                      <label>Currently following</label>
                    </div>
                  </div>
                </div>
                <div className="dash_ct_list">
                  <div className="dash_ct_list_title">
                    <span>Breakdown by master</span>
                  </div>
                  {masters.length > 0 ? masters.map((item) => {
                    const initial = String(item?.masterName || "M").trim().charAt(0).toUpperCase();
                    return (
                      <Link
                        key={item?.master_id || item?.masterName}
                        className="dash_ct_row"
                        to={item?.master_id ? `/copy-trading/${item.master_id}` : "/copy-trading"}
                      >
                        <span className="dash_ct_avatar">{initial}</span>
                        <div className="dash_ct_master">
                          <strong>{item?.masterName || "—"}</strong>
                          <span className={`dash_ct_chip ${item?.isFollowing ? "following" : ""}`}>
                            {item?.isFollowing ? "Following" : "Not following"}
                          </span>
                        </div>
                        <span className={`dash_ct_amount ${pnlClass(item?.totalPnl)}`}>
                          {pnlUsdt(item?.totalPnl)}
                        </span>
                      </Link>
                    );
                  }) : (
                    <div className="dash_ct_empty">
                      <p>No copy trades yet</p>
                      <span>Follow a master to start tracking PnL here.</span>
                      <Link to="/copy-trading">Explore masters</Link>
                    </div>
                  )}
                </div>
              </div>
            </div>

          </div>


          <div className="dashboard_right_side">
            <div className="new_features_s">
              <h4>Coming Soon</h4>
              <div className="features_block">
                <div className="block_features">
                  <img className='darkimg' src="/images/trading_bots.svg" alt="bots" />
                  <img className='lightimg' src="/images/trading_bots_light.svg" alt="bots" />
                  <div className="features_cnt">
                    <h5>Forex Trading Bot</h5>
                    <p>A Forex Trading Bot is an automated software that uses algorithms to execute buy and sell orders in the foreign exchange market without manual intervention.  </p>
                  </div>
                </div>

                <div className="block_features">
                  <img className='darkimg' src="/images/crypto_card.svg" alt="bots" />
                  <img className='lightimg' src="/images/crypto_card_light.svg" alt="bots" />
                  <div className="features_cnt">
                    <h5>NFT Market</h5>
                    <p>An NFT Marketplace is an online platform where you can create (mint), buy, sell, or trade NFTs (Non-Fungible Tokens) — which are unique digital assets stored on a blockchain. </p>
                  </div>
                </div>
              </div>

              <h4>Recommendations</h4>
              <div className="recommendations_block">
                <ul>
                  <li>
                    <div className="cv_trade_img">
                      <img src="/images/recommendations_vector.png" alt="recommendations" />
                    </div>
                    <div className="cnt_slider_f">
                      <h6>Complete Identity Verification</h6>
                      <p>Secure your account by completing identity verification.</p>
                      {props?.userDetails?.kycVerified === 0 ? (
                        <Link to="/user_profile/kyc">Verify</Link>
                      ) : props?.userDetails?.kycVerified === 1 ? (
                        <span style={{ color: "#fea903", fontWeight: "bold" }}>KYC Pending</span>
                      ) : props?.userDetails?.kycVerified === 2 ? (
                        <span style={{ color: "#fea903", fontWeight: "bold" }}>KYC Approved</span>
                      ) : props?.userDetails?.kycVerified === 3 ? (
                        <span style={{ color: "red", fontWeight: "bold" }}>KYC Rejected</span>
                      ) : null}
                    </div>
                  </li>
                  <li>
                    <div className="cv_trade_img">
                      <img src="/images/recommendations_vector2.png" alt="recommendations" />
                    </div>
                    <div className="cnt_slider_f">
                      <h6>2-Factor Authentication (2FA)</h6>
                      <p>Enhance your security with 2FA — an extra layer of protection for your account.</p>
                      {props?.userDetails?.["2fa"] === 0 ? (
                        <Link to="/user_profile/two_factor_autentication">Bind</Link>
                      ) : (
                        <span style={{ color: "#fea903", fontWeight: "bold" }}>2FA Activated</span>
                      )}
                    </div>
                  </li>
                  <li>
                    <div className="cv_trade_img">
                      <img src="/images/recommendations_vector3.png" alt="recommendations" />
                    </div>
                    <div className="cnt_slider_f">
                      <h6>Buy crypto with one-click</h6>
                      <p>Easily purchase crypto in seconds with just a single click </p>
                      <Link to="/asset_managemnet/deposit">Buy Crypto</Link>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

          </div>
        </div>
      </div>

    </>
  )
}

export default Dashboard
